import moment from 'moment';
import React, { useState } from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetResellerResponse from '../../../Api/CRM/Responses/ResellerResponse';
import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import ModifyParameterModal from '../../elements/ModifyParameterModal';
import { PERMISSION, ROLE } from '../../helpers/Permissions';
import ShowMetrics, { TYPE_METRICS } from '../../helpers/ShowMetrics';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import { ROLES } from '../../services/AdminPolicyService';
import AdminsList from '../admin/AdminsList';
import TicketsList from '../ticket/TicketsList';

import ResellerCommissionsList from './ResellerCommissionsList';
import ResellerDetails from './ResellerDetails';
import ResellerValueSum from './ResellerValueSum';

import { PageScrollerAnchor } from 'crm/elements/PageScrollerNavigation';

export default function ResellerShow() {
    const { id } = useNumberParams();
    const [reseller, setReseller] = useState<GetResellerResponse>({} as GetResellerResponse);
    const url = `/crea/api/reseller/${id}`;
    const resellerUrl = `/reseller/${id}`;
    const { loggedAdmin } = useGlobalState();

    useOnce(() => CRMApi.resellers.getById(id).then(setReseller));

    return (
        <>
            <PageScrollerAnchor name="Sale and revenue" />
            <div className="row">
                <ResellerValueSum modelId={id} humanReadableName="Sale" url={`${url}/sale`} />
                <ResellerValueSum modelId={id} humanReadableName="Revenue" url={`${url}/revenue`} />
                <ShowMetrics
                    url={`/crea/api/metrics/${id}`}
                    path="reseller_tickets_winnings"
                    label="Winnings"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={{ startDate: moment().add(-1, 'M'), endDate: moment() }}
                />
            </div>
            <div className="btn-list">
                <ModifyParameterModal
                    parameterName="reseller_debit"
                    value={reseller.reseller_debit}
                    action={(value) => CRMApi.resellers.updateDebit(id, parseInt(value)).then(setReseller)}
                    displayName="debit"
                    permissions={[PERMISSION.UPDATE_RESELLER]}
                    className="mb-3"
                />
            </div>
            <ResellerDetails reseller={reseller} />
            {loggedAdmin && !loggedAdmin.hasRole(ROLE.SUPER_AGENT) ? (
                <>
                    <ActionButton
                        url={`${resellerUrl}/attach/admin`}
                        title="Attach Super Agent"
                        roles={ROLES.MAIN_ADMINS}
                    />
                    <AdminsList source="reseller" relatedId={id} cardTitle="Super Agents" />
                </>
            ) : null}
            {loggedAdmin && !loggedAdmin.hasRole(ROLE.MASTER_AGENT) ? (
                <>
                    <TicketsList source="reseller" relatedId={id} />
                    <ResellerCommissionsList id={id} />
                </>
            ) : null}
        </>
    );
}
